import { Component, EventEmitter, Input, OnInit, Output, effect, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { FormationsService } from '../../../../../../services/formations.service';
import { FileSelectEvent, FileUpload, FileUploadEvent } from 'primeng/fileupload';
import { MessageService } from 'primeng/api';
import { HttpClient } from '@angular/common/http';
import { ViewChild } from '@angular/core';
import { environment } from '../../../../../../../environments/environments';


@Component({
  selector: 'app-formations-form',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, ButtonModule, FileUpload],
  templateUrl: './formations-form.component.html',
  styleUrl: './formations-form.component.scss'
})
export class FormationsFormComponent implements OnInit {
  @Output() formSubmit = new EventEmitter<any>();
  @Input() isEditMode: boolean = false;
  initialData = input<any | null>();
  uploadedFiles: any[] = [];

  @ViewChild('imageUploader') imageUploader!: FileUpload;
  @ViewChild('pdfUploader') pdfUploader!: FileUpload;
  private fb = inject(FormBuilder);
  private http = inject(HttpClient);
  private messageService = inject(MessageService)
  private formationsService = inject(FormationsService);
  pdfUrl: any = '';
  formationForm!: FormGroup;
  formationId: number | null = null;

  selectedImage: File | null = null;
  selectedPdf: File | null = null;

  constructor() {
    this.formationForm = this.fb.group({
      title: ['', [Validators.required, Validators.minLength(2)]],
      description: [''],
      image_url: ['', Validators.required],
      pdf_file: ['', Validators.required],
      price_eur: [0, [Validators.required, Validators.min(0)]],
      is_active: [true]
    });


    effect(() => {
      const data = this.initialData();
      if (data) {
        this.formationId = data.id ?? null;

        this.formationForm.patchValue({
          title: data.title ?? '',
          description: data.description ?? '',
          image_url: data.cover_image_path ?? '',
          price_eur: data.price_eur ?? 0,
          is_active: data.is_active ?? true,
          pdf_file: data.pdf_path
        });

        this.pdfUrl = `${environment.apiUrl}api/formations/pdf/${data.id}`;
      }
    });
  }




  ngOnInit(): void { }

  onSelectImage(event: FileSelectEvent) {
    this.selectedImage = event.files[0];
    this.formationForm.patchValue({ image_url: "selected" })
  }
  onSelectPdf(event: FileSelectEvent) {
    this.selectedPdf = event.files[0];
    this.formationForm.patchValue({ pdf_file: "selected" })

  }


  onSubmit(): void {
    console.log("the button edit was clicked ")
    if (this.formationForm.invalid && !this.isEditMode) {
      this.formationForm.markAllAsTouched();
      return;
    }
    // upload the image to cloudinary 
    if (!this.selectedImage) {
      if (this.isEditMode) {
        const formData = new FormData();
        formData.append('formationId', this.initialData().id);
        formData.append('title', this.formationForm.value.title);
        formData.append('description', this.formationForm.value.description);
        formData.append('price_eur', this.formationForm.value.price_eur);
        formData.append('is_active', this.formationForm.value.is_active);
        formData.append('pdf_file', this.selectedPdf as File);
        this.formSubmit.emit(formData);
        this.resetForm();
      }
      return
    }
    const formDataImage = new FormData()
    formDataImage.append('file', this.selectedImage);
    formDataImage.append('upload_preset', 'analytix');
    const cloudinaryUrl = 'https://api.cloudinary.com/v1_1/ds9embh9b/image/upload';
    this.http.post(cloudinaryUrl, formDataImage).subscribe({
      next: (res: any) => {
        const imageUrl = res.secure_url;
        console.log("this is the url of the image", imageUrl);
        const formData = new FormData();
        if (this.isEditMode) {
          formData.append('formationId', this.initialData().id);
        }
        formData.append('title', this.formationForm.value.title);
        formData.append('description', this.formationForm.value.description);
        formData.append('price_eur', this.formationForm.value.price_eur);
        formData.append('is_active', this.formationForm.value.is_active);
        formData.append('image_url', imageUrl);
        formData.append('pdf_file', this.selectedPdf as File);
        this.formSubmit.emit(formData);
        this.resetForm();
      },
      error: (err) => {
        console.log("error while uploading the image to cloudinary", err)
      }
    })

  }

  resetForm(): void {
    this.formationForm.reset({
      title: '',
      description: '',
      image_url: '',
      pdf_file: '',
      price_eur: 0,
      is_active: true
    });

    this.selectedImage = null;
    this.selectedPdf = null;

    this.imageUploader?.clear();
    this.pdfUploader?.clear();
  }



}
